<template>
  <!-- SISA layout for Files page only -->
  <div v-if="isSisaPage" class="w sisa-page">
    <HeaderPartSisa></HeaderPartSisa>
    <router-view/>
    <FooterPart></FooterPart>
  </div>

  <!-- Default layout for all other pages -->
  <div v-else class="page-wrap">
    <HeaderPart></HeaderPart>
    <div class="main-content">
      <router-view/>
    </div>
    <FooterPart></FooterPart>
  </div>
</template>

<style>
.page-wrap{ min-height:100vh; margin:0; }

.sisa-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.sisa-page > footer {
  margin-top: auto;
}

header{ min-height:50px; background:lightcyan; }
footer{ min-height:50px; background:PapayaWhip; }

/* Trick */
.page-wrap{
  display:flex;
  flex-direction:column;
}

footer{
  margin-top:auto;
}
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}
:root{
  --main-color: #0070c0;
  --second-color: #BF1613;
}
nav a.router-link-exact-active {
  color: #42b983;
}

h1, h2, h3, h4{
  color: var(--main-color)
}

.hero{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: left bottom 20%;
  min-height: 350px;
  padding-top: 1px;

}
</style>
<script>
import HeaderPart from "@/components/parts/HeaderPart";
import FooterPart from "@/components/parts/FooterPart";
import HeaderPartSisa from "@/components/parts/HeaderPartSisa";
export default {
  components: {
    FooterPart, 
    HeaderPart,
    HeaderPartSisa
  },
  computed: {
    isSisaPage() {
      return this.$route.name === 'files' || this.$route.name === 'archive';
    }
  },
  watch: {
    '$route'(to) {
      this.updateSisaStyles(to.name === 'files' || to.name === 'archive');
    }
  },
  methods: {
    updateSisaStyles(loadStyles) {
      // Remove existing SISA styles if they exist
      const existingLinks = document.querySelectorAll('link[data-sisa-style]');
      existingLinks.forEach(link => link.remove());

      // Add SISA styles only if on Files page
      if (loadStyles) {
        const cssFiles = [
          '/css/normalize.css',
          '/css/webflow.css',
          '/css/style.css'
        ];

        cssFiles.forEach(file => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = file;
          link.setAttribute('data-sisa-style', 'true');
          document.head.appendChild(link);
        });
      }
    }
  },
  mounted() {
    // Load SISA styles if starting on Files page
    this.updateSisaStyles(this.$route.name === 'files' || this.$route.name === 'archive');
  }
}
</script>